<template>
  <div
    class="modal hide-footer no-stacking"
    id="ConfirmDeleteAuth0AccountModal"
    data-test-hook="modal-title-confirm-delete-auth0-acct-modal"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header pb-1 pt-1 pr-0 align-items-center">
          <h2 class="modal-title" style="font-size: 1.25rem;">
            <i
              class="far fa-circle-exclamation colorOrange mr-1"
              data-test-hook="modal-heading-confirm-delete-auth0-acct-modal"
            ></i>
            {{ $t('xPleaseAcknowledgeDeletingEffects') }}
          </h2>
          <button
            class="btn btn-icon-button btn-icon-button--gray"
            @click="
              trackAppInsightsEvent('ConfirmDeleteAuth0AccountModal-close-modal-pressed', {
                page: 'Confirm Delete Auth0 Account Modal',
                userId: accountProfile?.userId
              }),
                closeModal()
            "
            data-test-hook="x-close-btn-confirm-delete-auth0-acct-modal"
          >
            <i class="fas fa-times fa-sm " />
          </button>
        </div>

        <div class="modal-body pt-0 pb-0">
          <div align-h="around" class="row mt-3">
            <div class="col ml-0 mr-3" data-test-hook="modal-body-text-1-confirm-delete-auth0-acct-modal">
              <b>{{ $t('xThisProcessMayTakeDays') }} </b>
            </div>
          </div>
          <div align-h="around" class="row mt-0">
            <b-row class="mt-4 ml-0 mr-1">
              <b-col class="d-flex align-items-center">
                <b-form-checkbox
                  v-model="notAbleToUseMLCheckbox"
                  data-test-hook="no-longer-able-to-use-ml-checkbox-consent"
                  class="first-checkbox"
                >
                  {{ $t('xNoLongerAbleToUseML') }}
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row class="mt-3  ml-0 mr-1">
              <b-col class="d-flex align-items-center">
                <b-form-checkbox
                  v-model="ecobeeHomesRemovedCheckbox"
                  data-test-hook="ecobee-homes-removed-checkbox-consent"
                >
                  {{ $t('xEcobeeHomesWillBeRemoved') }}
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row class="mt-3 ml-0 mr-1 mb-2">
              <b-col class="d-flex align-items-center">
                <b-form-checkbox v-model="dataWillBeDeletedCheckbox" data-test-hook="cannot-be-undone-checkbox-consent">
                  {{ $t('xCannotBeUndone') }}
                </b-form-checkbox>
              </b-col>
            </b-row>
            <div v-if="this.showErrorText" align-h="around" class="row mt-2">
              <div class="col ml-3 mr-3 text-danger" data-test-hook="error-text-confirm-delete-auth0-acct-modal">
                {{ $t('xMustAcknowledgeEffects') }}
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer d-flex mt-3 p-0">
          <button
            type="button"
            class="btn btn-secondary my-3 ml-3"
            style="flex: 1 1 0;"
            @click="
              trackAppInsightsEvent('ConfirmDeleteAuth0AccountModal-close-modal-pressed', {
                page: 'Confirm Delete Auth0 Account Modal',
                userId: accountProfile?.userId
              }),
                closeModal()
            "
            data-test-hook="cancel-btn-confirm-delete-auth0-acct-modal"
          >
            {{ $t('xCancel') }}
          </button>
          <button
            class="btn btn-primary my-3 mr-3"
            style="flex: 1 1 0;"
            @click="onDeleteAccountPress()"
            data-test-hook="delete-btn-confirm-delete-auth0-acct-modal"
          >
            {{ $t('xDeleteAccountBtn') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  props: ['accountProfile'],
  data() {
    return {
      notAbleToUseMLCheckbox: false,
      ecobeeHomesRemovedCheckbox: false,
      dataWillBeDeletedCheckbox: false,
      showErrorText: false,
      deleteAccountURL: process.env.VUE_APP_AUTH0_DELETE_ACCOUNT_URL
    }
  },
  methods: {
    closeModal() {
      this.notAbleToUseMLCheckbox = false
      this.ecobeeHomesRemovedCheckbox = false
      this.dataWillBeDeletedCheckbox = false
      this.showErrorText = false
      document.getElementById('ConfirmDeleteAuth0AccountModal').style.display = 'none'
    },
    onDeleteAccountPress() {
      this.trackAppInsightsEvent('ConfirmDeleteAuth0AccountModal-delete-account-pressed', {
        page: 'Confirm Delete Auth0 Account Modal',
        userId: this.accountProfile?.userId,
        notAbleToUseMLCheckboxChecked: this.notAbleToUseMLCheckbox,
        ecobeeHomesRemovedCheckboxChecked: this.ecobeeHomesRemovedCheckbox,
        dataWillBeDeletedCheckbox: this.dataWillBeDeletedCheckbox
      })
      if (this.notAbleToUseMLCheckbox && this.ecobeeHomesRemovedCheckbox && this.dataWillBeDeletedCheckbox) {
        this.closeModal()
        window.open(this.deleteAccountURL, '_blank')
      } else {
        this.showErrorText = true
      }
    }
  }
}
</script>
<style scoped>
.modal-dialog {
  max-width: 600px !important;
}

::v-deep .first-checkbox .custom-control-label::before,
::v-deep .first-checkbox .custom-control-label::after {
  top: 1rem;
}
</style>
